import { StartNode, EndNode, ActionNode } from './CustomNodes';

export const nodeTypes = {
    start: StartNode,
    end: EndNode,
    send_form: ActionNode,
    wait_event: ActionNode,
    noop: ActionNode,
    set_vars: ActionNode,
    send_payment_link: ActionNode,
    process_payment: ActionNode,
    create_reservation: ActionNode,
    send_text: ActionNode,
    send_image: ActionNode,
    send_button_message: ActionNode,
    send_list_message: ActionNode,
    send_catalog_message: ActionNode,
    send_single_product_message: ActionNode,
    send_multi_product_message: ActionNode,
    send_product_carousel: ActionNode,
};

export const initialNodes = [];
